/** Nombres de parámetros de consulta (query params) usados en la navegación. */
export enum ParametroConsulta {
  URL_RETORNO = 'urlRetorno',
}
